import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../services/auth.service';
import {TokenStorageService} from '../../services/storage/token-storage.service';
import {UserService} from '../../services/user.service';
import {AppConfigService} from "../../services/config/app-config.service";

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrl: './login-page.component.css',
    standalone: false
})
export class LoginPageComponent implements OnInit {

  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  });
  submitted: boolean = false;
  loading: boolean = false;
  gettingUserDetails: boolean = false;
  status: any;
  userType:string | null = "";
  user: any;
  userApiTypes: any[] =[];


  constructor(private formBuilder: FormBuilder,
              private authService: AuthService,
              private tokenStorage: TokenStorageService,
              private toastr: ToastrService,
              private activatedRoute: ActivatedRoute,
              private userService: UserService,
              private appConfig: AppConfigService,
              private router: Router) {
    this.userType = tokenStorage.getUserType();

  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.status = params.get('status')
    });
    this.initializeForm();
  }

  initializeForm(): void {
    this.form = this.formBuilder.group(
      {
        username: [
          '',
          [
            Validators.required
          ]
        ],
        password: [
          '',
          [
            Validators.required
          ]
        ]
      }
    );
  }

  onClickSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.toastr.error('Please enter the details', 'Login failed');
      return;
    }

    const {username, password} = this.form.value;
    this.loading = true;
    if (this.userType == "OMS") {
      this.authService.login(username, password).subscribe(
        {
          next: (data) => {
            this.loading = false;
            if (data.status == 'SUCCESS') {
              this.gettingUserDetails = false;
              this.tokenStorage.saveToken(data.accessToken);
              this.tokenStorage.saveRefreshToken(data.refreshToken);
              this.tokenStorage.saveUser(data.user);

              let env = 'asia';
              if(data.role!='admin'){
                env = data.user.region;
              }
              this.tokenStorage.saveUserEnv(env);
              if (data.user?.initialLoginFlag === 1) {
                this.router.navigate(['/login/change-password']);
              } else {
                this.authService.changeLoginStatus(true);
                this.toastr.success('Logged in as a ' + data.user.role + ' user', 'Login success');
                this.reloadPage();
              }
            } else {
              this.toastr.error(data.reason, 'Login failed');
            }
          },
          error: (err) => {
            this.loading = false;
            this.toastr.error(err.error.message, 'Login failed');
          }
        }
      );
    } else if (this.userType == "FEED") {
      this.authService.getFeedUserRefreshToken(username, password).subscribe(
        {
          next: (data) => {
            if (data.refresh_token != null) {
              this.authService.getFeedUserAccessToken(data.refresh_token).subscribe(
                {
                  next: (res) => {
                    if (res.access_token != null) {
                      this.loading = false;
                      this.authService.changeLoginStatus(true);
                      this.tokenStorage.saveToken(res.access_token);
                      this.toastr.success('Logged in as a ' + this.userType + '', 'Login success');
                      this.gettingUserDetails = false;
                      this.tokenStorage.saveUser(res);
                      this.reloadPage();
                    } else {
                      this.loading = false;
                      this.toastr.error(data.reason, 'Login failed');
                    }
                  }
                });
            } else {
              this.toastr.error(data.reason, 'Login failed');
            }
          },
          error: (err) => {
            this.loading = false;
            this.toastr.error(err.error.message, 'Login failed');
          }
        }
      );

    }





  }

  reloadPage(): void {
    window.location.reload();
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

}
